/**
 * @description
 *	A list of ISO 639-1 alpha-2 language codes.
 *
 * @see https://en.wikipedia.org/wiki/List_of_ISO_639_language_codes
 */
enum LanguageCode {
	English = "en",
	Spanish = "es"
}

export default LanguageCode
